<template>
    <div>

<section class="content">
<div class="container-fluid">

        <div class="row clearfix">

            <div class="bg-light-green" style="margin-top:-1% !important;">
                <!-- <br> -->
                <div class="row paddingku">
                    <div class="col-md-3 searching">
                        <span class="h_page">Pembuatan Zona Nilai Tanah</span> <br> <br>
                    </div>
                    <div class="col-md-6">

                    </div>
                    <div class="col-md-3 searching">
                        <div class="input-group">                            
                            <select class="form-control" v-model="tab">
                                <option>Pembuatan Tabel Blok</option>
                                <option>Pembuatan Tabel Peta ZNT</option>
                                <option>Perubahan NIR</option>
                                <option>Perubahan ZNT Massal</option>
                                <option>Perubahan ZNT Terseleksi</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>


            <div class="col-xs-12 card">
        <!-- ============================================================ MULAI ======================================================================== -->
                <div v-if ="tab == 'Pembuatan Tabel Blok'">
                    <bhumie_tab_pembuatan_tabel_blok></bhumie_tab_pembuatan_tabel_blok>
                </div>

                <div v-if ="tab == 'Pembuatan Tabel Peta ZNT'">
                    <bhumie_tab_pembuatan_tabel_peta_znt></bhumie_tab_pembuatan_tabel_peta_znt>
                </div>

                <div v-if ="tab == 'Perubahan NIR'">
                    <bhumie_tab_perubahan_nir></bhumie_tab_perubahan_nir>
                </div>

                <div v-if ="tab == 'Perubahan ZNT Massal'">
                    <bhumie_tab_perubahan_znt_massal></bhumie_tab_perubahan_znt_massal>
                </div>

                <div v-if ="tab == 'Perubahan ZNT Terseleksi'">
                    <bhumie_tab_perubahan_znt_terseleksi></bhumie_tab_perubahan_znt_terseleksi>
                </div>

        <!-- ============================================================ MULAI ======================================================================== -->
            </div>

        </div>

        </div>
      </section>



    </div>
</template>


<script>

const ADD_URL = URL_APP+'api/v1/kecamatan/';


export default {
  name: "monev_kabupaten",
  data() {
    return {
        tab : 'Pembuatan Tabel Blok',
    };
  },

// =============================================================== METHODS =========================================================================
  methods : {


  },
// =============================================================== METHODS =========================================================================

  mounted() {
    localStorage.sidemenu = 'bhumie';
  },
};
</script>
